import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import AddFlow from "./AddFlow";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { useGetAllFlowMutation, useGetFlowByIdMutation } from "./Api";
import { FaEdit } from "react-icons/fa";

const KBFlowTable = () => {

    const [getAllFlowApi, { isLoading }] = useGetAllFlowMutation()
    const [getFlowByIdApi, { isLoading: getFlowByIdIsloading }] = useGetFlowByIdMutation()

    const [flow, setFlow] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const navigate = useNavigate()

    const requestIdRef = useRef(0);

    const searchInputRef = useRef(null);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    useEffect(() => {
        getAllFlow()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);


    const getAllFlow = async () => {
        try {
            const requestId = ++requestIdRef.current;

            const response = await getAllFlowApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch
            })

            // keep cursor in search input
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 1);

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                setFlow(response?.data?.data?.flow)
                setTotalRecords(response?.data?.data?.pagination.total || 0);
                setTotalPages(response?.data?.data?.pagination.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // Drawer open close
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Open drawer for creating new dropdown
    const handleCreateFlow = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = () => {
        handleCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new intent upload
    };

    // Update Drawer
    const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
    const [intentData, setIntentData] = useState()

    const handleUpdateCloseDrawer = () => {
        setIsUpdateDrawerOpen(false);
    };

    const handleUpdateSave = () => {
        handleUpdateCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };


    const getFlowById = async (id) => {
        try {
            const response = await getFlowByIdApi({ id: id })

            if (response.data.success) {
                setIsUpdateDrawerOpen(true)
                setIntentData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || getFlowByIdIsloading ? <Loader /> :
                <div className="card p-3 mb-4">
                    <div className="card shadow-sm border-0 p-3 mb-4">
                        <div className="row justify-content-end g-3">

                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <input
                                    ref={searchInputRef}
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search flow by name..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            <div className="col-12 col-sm-6 col-md-3 col-lg-auto">
                                <button className="btn btn-primary btn-compact" onClick={handleCreateFlow}>
                                    Create Flow
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Intent Name</th>
                                    <th>Flow Name</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading && flow?.length > 0 ? (
                                    flow.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item["intentData.intent_name"]}</td>
                                            <td>{item.flow_name}</td>
                                            <td>{item.description}</td>
                                            <td>
                                                <span
                                                    className={`badge ${item.status === "active"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                        }`}
                                                >
                                                    {item.status
                                                        ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
                                                        : "-"}
                                                </span>
                                            </td>
                                            <td
                                                style={{ cursor: "pointer" }}
                                                onClick={() => getFlowById(item.id)}
                                            >
                                                <FaEdit size={18} />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* Pagination */}

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                            <div className="d-flex align-items-center gap-1 small">

                                <span>Show</span>

                                <select
                                    className="form-select form-select-sm page-size-select"
                                    value={rowsPerPage}
                                    onChange={(e) => {
                                        setRowsPerPage(Number(e.target.value));
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                </select>

                                <span>entries</span>

                            </div>

                            <div className="small text-muted">
                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                            </div>

                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                maxPagesToShow={rowsPerPage}
                                onPageChange={(page) => setCurrentPage(page)}
                            />

                        </div>
                    </div>
                    {isDrawerOpen && (
                        <AddFlow
                            mode="add"
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}

                    {isUpdateDrawerOpen && (
                        <AddFlow
                            mode="update"
                            onClose={handleUpdateCloseDrawer}
                            onSave={handleUpdateSave}
                            data={intentData}
                        />
                    )}
                </div>
            }
        </div>
    );
};

export default KBFlowTable;